import axios from 'axios';
import { GeoCompany } from 'models/response';
import { trackPromise } from 'react-promise-tracker';

import { GBS } from '../utils/constants';

/**
 * This API return geo companies
 * @return {Promise<AxiosResponse<GeoCompany[]>>}
 */
const getGbsCompanies = () => trackPromise(axios.get<GeoCompany[]>(`${GBS}/getGbsCompanies`), 'module');

export default {
  getGbsCompanies,
};
